import qs, { type IParseOptions, type IStringifyOptions } from 'qs';

export const INTEGRATED_OFFER_ROUTE = 'activation/integrated-offer';
export const PACKAGE_ACTIVATION_ROUTE = `${INTEGRATED_OFFER_ROUTE}/packages`;
export const BOOKING_INTENT_ROUTE = `${INTEGRATED_OFFER_ROUTE}/booking-intents`;
export const UTILITIES_ROUTE = 'activation/utilities';
export const ACTIVATIONS_ROUTE = 'activation/activations';
export const BILLING_ROUTE = 'billing';
export const ERROR_ROUTE = 'error';
export const FREE_TRIAL_ROUTE = 'activation/free-trial';

export const routes = [
    UTILITIES_ROUTE,
    ACTIVATIONS_ROUTE,
    INTEGRATED_OFFER_ROUTE,
    PACKAGE_ACTIVATION_ROUTE,
    BOOKING_INTENT_ROUTE,
    FREE_TRIAL_ROUTE,
];

export const STRINGIFY_OPTIONS: IStringifyOptions = {
    // required to stringify arrays into comma separated strings
    arrayFormat: 'comma',
    // don't use array indices
    indices: false,
    // don't encode the entire string as it will be done individually for certain params
    encode: false,
    // required to remove empty params
    skipNulls: true,
};

export const PARSE_OPTIONS: IParseOptions = {
    // required to parse comma separated string into array
    comma: true,
};

export interface RouteState {
    myId: string | undefined;
    anotherId: string | undefined;
}

export const parseRoute = (locationSearch: string): RouteState => {
    const decodedSearch = decodeURIComponent(locationSearch.replace('?', ''));
    const { myId, anotherId } = qs.parse(decodedSearch, PARSE_OPTIONS);
    return {
        myId,
        anotherId,
        // add other url params and convert them to the right type here
        // in order to easily work with them in the RouteUpdater component
    } as RouteState;
};
